export default {
  SET_REV(state, rev) {
    state.rev = rev
  },
  SET_CHALLENGE(state, payload) {
    state.challenge = payload.challenge
  },
}
